import React from 'react';
import ReactDOM from 'react-dom/client';

import './env';
import './index.css';
import './assets/css/main.css';
import './assets/js/main.js';

import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <App />
);

reportWebVitals();